import { createIcon } from '../createIcon';
import { ReactComponent as IconPrint } from '../svg/print.svg';

export default createIcon(IconPrint);
